"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17 2H7c-.55 0-1 .45-1 1s.45 1 1 1h7.59L2.29 16.29a1.003 1.003 0 001.42 1.42L16 5.41V13c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1z"];
//# sourceMappingURL=arrow-top-right.js.map